import React, { useEffect } from 'react'
import { Button, Card } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Layout from '../../home/theme/Layout'
import { doRequestPost } from '../../../api'

export default function CartSuccess() {
  const history = useHistory()
  const { id_customers_reservation_event_zone } = useSelector(
    state => state.sessioncustomer
  )

  useEffect(() => {
    doRequestPost({
      url: '/event/customer/pending/wallet',
      data: {
        p_id_customers: id_customers_reservation_event_zone
      }
    })
  }, [id_customers_reservation_event_zone])

  return (
    <Layout title="Pago exitoso">
      <div className="container py-4 py-lg-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">

            <Card className="shadow-sm border-0">
              <Card.Body className="d-flex flex-column align-items-center text-center py-5 px-4">

                {/* Ícono de éxito */}
                <i className="fa fa-check-circle text-success fa-4x mb-3" />

                {/* Título */}
                <h1 className="h4 mb-2 fw-bold">¡Pago realizado con éxito!</h1>

                {/* Mensaje */}
                <p className="text-muted mb-4">
                  Tu compra ha sido procesada correctamente.
                  <br />
                  Revisa tu bandeja de entrada: te enviamos tus boletos y
                  la confirmación de tu compra.
                </p>

                {/* Botones */}
                <div className="d-flex flex-column flex-sm-row gap-2">
                  <Button
                    variant="primary"
                    className="mb-2 mb-sm-0 me-sm-2"
                    onClick={() => history.push('/mis-tickets')}
                  >
                    Ver mis tickets
                  </Button>

                  <Button
                    variant="outline-secondary"
                    onClick={() => history.push('/')}
                  >
                    Ir al inicio
                  </Button>
                </div>

                {/* Nota */}
                <p className="small text-muted mt-4 mb-0">
                  Si no encuentras el correo, revisa tu carpeta de spam o promociones.
                </p>
              </Card.Body>
            </Card>

          </div>
        </div>
      </div>
    </Layout>
  )
}
